export default __webpack_public_path__ + "static/char-s-01-en-cfc40d0af08e5a9e26dca3f0de9135bf.webp";